import ArtNopicItem from './art-nopic-item.vue';
import ArtOnepicItem from './art-onepic-item.vue';
import ArtAtlas from './art-atlas.vue';
import ArtNewsList from './art-news-list.vue';
import ArtInsertConfig from './article_config.js'
function ArticleInsertRec(opt) {
    this.data = opt.data;
    this.$el = opt.el;
    this.dataType = opt.dataType;
    this.templateSpm = opt.templateSpm;
}
ArticleInsertRec.prototype = {
    constructor: ArticleInsertRec,
    /**
     * @description 初始化卡片，先渲染再插入
     */
    init: function(){
        var articleDom = this.render(this.data)
        this.$el.appendChild(articleDom)

    },
    /**
     * @description 渲染函数
     * @param {*} data
     * @returns
     */
    render: function(data) {
        //卡片类型
        var insertType = this.dataType;
        var ArticleItem = this.getTmplateName(insertType);
        var ArticleCon = Vue.extend(ArticleItem);
        var artItem = new ArticleCon({
            el: document.createElement('div'),
            data: {
                articleData: data,
                templateSpm: this.templateSpm
            }
        });
        return artItem.$el;
    },
    /**
     * @description 获取卡片类型和模板的对应关系
     * @param {*} type
     * @returns
     */
    getTmplateName: function (type) {
        switch(+type) {
            case ArtInsertConfig.articleNoPic:
                return ArtNopicItem
            break;
            case ArtInsertConfig.articleOnePic:
                return ArtOnepicItem
            break;
            case ArtInsertConfig.list:
                return ArtNewsList
            break;
            case ArtInsertConfig.atlas:
                return ArtAtlas
            break;
            default:
            break;

        }
    }
}
export default ArticleInsertRec;
